import React from 'react';
import { Box, Button, Typography, Dialog } from '@mui/material';
import { styled } from '@mui/system';

const StyledDialogContent = styled(Box)({
  padding: '24px',
  minWidth: '250px',
  maxWidth: 'min(90vw, 400px)',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const StyledHeader = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.1rem',
  color: '#d48aae',
  textAlign: 'center',
  textShadow: '0 2px 4px rgba(0, 0, 0, 0.4)',
  marginBottom: '20px',
});

const PrimaryButton = styled(Button)({
  fontFamily: 'Playfair Display, serif',
  fontWeight: 500,
  fontSize: '0.88rem',
  letterSpacing: '0.07em',
  textTransform: 'none',
  color: '#d48aae',
  background: `
    radial-gradient(ellipse at 50% 0%, rgba(160, 55, 120, 0.18), transparent 65%),
    linear-gradient(to bottom, #2e0f20 0%, #1e0916 55%, #160710 100%)
  `,
  border: '1px solid rgba(160, 55, 110, 0.28)',
  borderRadius: '50px',
  padding: '9px 18px',
  margin: '0 6px',
  boxShadow: '0 0 14px rgba(140, 40, 95, 0.15), 0 3px 10px rgba(0, 0, 0, 0.5)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'scale(1.03)',
    boxShadow: '0 0 20px rgba(155, 50, 110, 0.25), 0 4px 14px rgba(0, 0, 0, 0.58)',
  },
});

const BackButton = styled(PrimaryButton)({});

const PopoverCard = ({
  mainText,
  open,
  onClose,
  showButtonOne,
  showButtonTwo,
  textButtonOne,
  textButtonTwo,
  onButtonOne,
  onButtonTwo,
  hideBack,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: `
            radial-gradient(ellipse at 20% 10%, rgba(89, 18, 51, 0.22) 0%, transparent 52%),
            radial-gradient(ellipse at 80% 90%, rgba(64, 13, 41, 0.18) 0%, transparent 48%),
            rgba(26, 8, 20, 0.95)
          `,
          borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.55)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(89, 18, 51, 0.22)',
          overflow: 'hidden',
        },
      }}
    >
      <StyledDialogContent>
        {mainText && <StyledHeader>{mainText}</StyledHeader>}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, flexWrap: 'wrap', width: '100%' }}>
            {showButtonOne && (
              <PrimaryButton sx={{ flex: 1, minWidth: '140px', maxWidth: '200px' }} onClick={onButtonOne}>
                {textButtonOne}
              </PrimaryButton>
            )}
            {showButtonTwo && (
              <PrimaryButton sx={{ flex: 1, minWidth: '140px', maxWidth: '200px' }} onClick={onButtonTwo}>
                {textButtonTwo}
              </PrimaryButton>
            )}
          </Box>
          {!hideBack && (
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <BackButton onClick={onClose}>Back</BackButton>
            </Box>
          )}
        </Box>
      </StyledDialogContent>
    </Dialog>
  );
};

export default PopoverCard;

